import { render, staticRenderFns } from "./AddEdtDeptDlg.vue?vue&type=template&id=ee61efb2"
import script from "./AddEdtDeptDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtDeptDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports